module.exports = {
  ...require('./BaseModel'),
  name: 'ChartModel',
  fields: {
    ...require('./BaseModel').fields,
  }
}
